import styled, { css } from 'styled-components';
import { SPACING } from '@optimus-web/local-tokens';
import { SizeType } from '../types';

export const ValueContainerElement = styled.div<{ size?: SizeType }>`
    flex-grow: 1;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    position: relative;
    padding: 6px ${SPACING[200]}px;
    box-sizing: border-box;
    min-width: 0;
    margin-top: 1px;
    margin-bottom: 1px;
    cursor: text;

    & > * {
        margin-top: 1px;
        margin-bottom: 1px;

        &:not(:last-child) {
            margin-right: ${SPACING[50]}px;
        }
    }

    ${(props) =>
        props.size === 'small' &&
        css`
            padding: 2px ${SPACING[100]}px;
        `}

    ${(props) =>
        props.size === 'large' &&
        css`
            padding: 9px ${SPACING[200]}px;
        `}
`;
